const cache = {};

function camelize(str) {
  if (!cache[str]) {
    cache[str] = str.replace(
      /[-_](\w)/gi,
      (_, char) => (char ? char.toUpperCase() : '')
    );
  }

  return cache[str];
}

export default function camelCase(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  } else if (obj instanceof Array) {
    return obj.map(camelCase);
  }

  const res = {};
  Object.keys(obj).forEach(key => {
    res[camelize(key)] = camelCase(obj[key]);
  });

  return res;
}
